import * as React from "react";
import { useEffect, useState } from "react";
import { IReduxState } from "reducers";
import { connect } from "react-redux";
import { deliveryPincodeCheck } from "egold/actions";
import { TextField } from "components/common/inputFunctions";
import ImageSlider from "components/slider";
import { insideHeader, renderProceed } from "egold/utils";
import { RouteComponentProps, Redirect } from "react-router-dom";
import { handleNavigation, indexPath, routePaths } from "egold/routes";
import {
    IEgoldUserDetails,
    IGoldBalance,
    IGoldProductDetails,
    IPincodeDetails,
} from "StateInterface";
import { notifyAndroid } from "utils/android";
import { imageBaseUrl } from "config";
import { vendor } from "egold/egold-config";
interface IConnectProps {
    dispatch?: (action: any) => void;
    products: IGoldProductDetails[];
    pincodeDetails: IPincodeDetails;
    productIndex: number;
    lockerBalance: IGoldBalance;
    isAndroid: boolean;
    eGoldUserDetails: IEgoldUserDetails;
}

function ProductDetails(props: IConnectProps & RouteComponentProps) {
    const [userInput, updateUserInput] = useState<any>({pincode: ""});
    function handleChange(fieldName: string, value: number | string) {
        updateUserInput((prevState: any) => {
            return {
                ...prevState,
                [fieldName]: value,
            };
        });
    }
    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.eGoldUserDetails) {
            updateUserInput({ pincode: props.eGoldUserDetails.pin_code });
            props.dispatch(
                deliveryPincodeCheck(vendor.SAFEGOLD, props.eGoldUserDetails.pin_code)
            );
        }
        if (props.isAndroid)
            notifyAndroid("TOOL_BAR_CONFIG", { visibility: false });
    }, []);
    function handleProceed() {
        handleNavigation(routePaths.DELIVERY_DETAILS);
    }
    function pincodeCheck() {
        props.dispatch(deliveryPincodeCheck(vendor.SAFEGOLD, userInput.pincode));
    }
    function renderPincodeCheck() {
        return (
            <div className="position-relative">
                <div className="mt-3 deliver-text">
                    <small>Delivers To</small>
                </div>
                <TextField
                    label="Pincode"
                    value={userInput.pincode}
                    fieldName="pincode"
                    onChange={handleChange}
                    type="number"
                    placeholder={"Enter delivery pincode"}
                    inputTextClass="line-input-box"
                />
                {props.pincodeDetails && (
                    <div>
                        {props.pincodeDetails.is_valid ? (
                            <small className="text-success">
                                Available,&nbsp;
                                {props.pincodeDetails.pincode} {props.pincodeDetails.city}
                            </small>
                        ) : (
                            <small className="text-danger">Not deliverable</small>
                        )}
                    </div>
                )}
                <small className="d-block">Check pincode for exact delivery</small>
                <button className="pin-check-button" onClick={() => pincodeCheck()}>
                    Change
                </button>
            </div>
        );
    }
    if (props.productIndex === null || props.productIndex === undefined) {
        return <Redirect to={`${indexPath}${routePaths.DELIVERY}`} />;
    }

    const isEligibleToBuy = Number(props.lockerBalance && props.lockerBalance.gold_balance) >=
                            Number(props.products[props.productIndex].metal_weight);
    const isActive = props.pincodeDetails &&
                     props.pincodeDetails.is_valid &&
                     isEligibleToBuy &&
                     props.products[props.productIndex].in_stock;
    return (
        <div className="text-field-container">
            {insideHeader("Gold Delivery", props.history.goBack)}
            <ImageSlider
                images={props.products[props.productIndex].images}
                dots={true}
                onImageError={`${imageBaseUrl}/img/icons/eGold/gold-coin.png`}
            />
            <h4 className="egold-title-text">
                {props.products[props.productIndex].description}
            </h4>
            <h6 className="egold-sub-text">
                Making Charges Rs. {props.products[props.productIndex].making_charges}
            </h6>
            <small className="m-0">
                Powered by:{" "}
                <img
                    className="my-2"
                    src={`${imageBaseUrl}/img/icons/eGold/safegold_logo.svg`}
                    style={{ width: "100px" }}
                />
            </small>
            <div>
                {props.products[props.productIndex].in_stock ? (
                    <small className="text-success">In stock</small>
                ) : (
                    <small className="text-danger"> Out of stock </small>
                )}
            </div>
            {!isEligibleToBuy && (
                <small className="text-danger">Insufficient Gold Balance.</small>
            )}
            {renderPincodeCheck()}
            {renderProductDetails(props.products[props.productIndex])}
            {renderProceed("Confirm", handleProceed, !isActive)}
        </div>
    );
}

function renderProductDetails(product: IGoldProductDetails) {
    return (
        <div className="table-border mt-4">
      <span className="d-block egold-bg-light egold-sub-text pl-2 py-2">
        Product Details
      </span>
            <table className="table table-borderless table-sm">
                <tbody style={{ fontSize: "13px" }}>
                <tr>
                    <td>Modal</td>
                    <td className="text-right"> {product.description}</td>
                </tr>
                <tr>
                    <td>Metal purity</td>
                    <td className="text-right">{product.purity ? product.purity : 99.5}%</td>
                </tr>
                <tr>
                    <td>Packaging</td>
                    <td className="text-right">{product.packaging_type}</td>
                </tr>
                <tr>
                    <td>Weight</td>
                    <td className="text-right">{Number(product.metal_weight).toFixed(2)}gm</td>
                </tr>
                </tbody>
            </table>
            <div className="px-1">
                <span className="egold-sub-text">Refund Policy</span>
                <br />
                <small>{product.refund_policy}</small>
            </div>
        </div>
    );
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        products: state.eGold.products,
        pincodeDetails: state.eGold.pincodeDetails,
        productIndex: state.eGold.selectedProductIndex,
        lockerBalance: state.eGold.goldBalance,
        isAndroid: state.login.isAndroid,
        eGoldUserDetails: state.eGold.eGoldUserDetails,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(ProductDetails);
